module.exports = __webpack_public_path__ + "assets/img/right-arrow-blue-light.cdc6ac63.svg";